import { SCRIPTS_LAUNCH_CONFIG } from "../constants";

export class Sentinel {
  constructor(updatedConfig) {
    this.invalidFileStates = ["Fail", "Pending"];
    this.config = updatedConfig;
    this.currentStepObj = updatedConfig[0];
    this.scriptsLaunchConfig = SCRIPTS_LAUNCH_CONFIG;
    this.scriptsQueue = [];
    this.filesQueue = [];

    // calling the methods here to compute everything as soon as it is initialised.
    this._updateCurrentStep();
    this._calculateLaunchableScripts();
  }

  _updateCurrentStep() {
    for (const fileState of this.config) {
      if (this.invalidFileStates.includes(fileState.status)) {
        this.currentStepObj = fileState;
        return;
      }
    }
  }

  _identifyUploadableFiles(stepId) {
    return this.config.filter((item) => item.id <= stepId);
  }

  _calculateLaunchableScripts() {
    this.scriptsQueue = [];
    for (let key in this.scriptsLaunchConfig) {
      let scriptConfigObj = this.scriptsLaunchConfig[key];
      if (
        this.currentStepObj.id >= scriptConfigObj.currentStepIdRequiredToLaunch
      ) {
        // re-init file queue
        this.filesQueue = this._identifyUploadableFiles(
          scriptConfigObj.stepSucceededIdRequiredToLaunch
        );

        const correspondingFile = this.filesQueue.find(
          (item) => item.id === scriptConfigObj.stepSucceededIdRequiredToLaunch
        );
        if (correspondingFile.status === "Skipped") {
          scriptConfigObj.skipped = true;
        }

        scriptConfigObj.isLaunchable = true;
        this.scriptsQueue.push(scriptConfigObj);
      }
    }
  }

  checkToggable(stepObj) {
    if (stepObj.id > this.currentStepObj.id) {
      return false;
    }
    return true;
  }

  update(updatedConfig) {
    this.config = updatedConfig;
    this._updateCurrentStep();
    this._calculateLaunchableScripts();
  }
}
